// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field-label[data-v-e8ddba3c]{\n  vertical-align: middle;\n}\n.box-card[data-v-e8ddba3c] {\n  width: 400px;\n  max-width: 100%;\n  margin: 20px auto;\n}\n.block[data-v-e8ddba3c] {\n  padding: 30px 24px;\n}\n.tag-item[data-v-e8ddba3c] {\n  margin-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
